module.exports = __webpack_public_path__ + "img/exam-button.5daafa1e.png";